import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans } from 'react-i18next';

import CancelButton from './CancelButton';

import * as S from '../styled';

const CancelSubscriptionBlock = ({
    date,
    isOneTimeProduct = false,
    onCancel,
}: {
    date?: string;
    isOneTimeProduct?: boolean;
    onCancel: () => void;
}) => {
    return isOneTimeProduct ? (
        <S.AdditionalStatusInfo $mb={0}>
            <Text color="text-secondary">
                <Trans
                    i18nKey="subscription.oneTime.disclaimer"
                    values={{
                        date,
                    }}
                />
            </Text>
        </S.AdditionalStatusInfo>
    ) : (
        <CancelButton onCancel={onCancel} />
    );
};

export default CancelSubscriptionBlock;
